import React, {FC} from 'react';
import styled from 'styled-components';

import {boxShadow} from '../../../../libs/shared/ui/src/theme/themeStyleHelpers';

/*
 * Props.
 */

export interface FloatingBarProps {
  className?: string;
}

/*
 * Style.
 */

const StyledBarDiv = styled.div`
  margin: 4px;
  overflow: hidden;
  border-radius: 10px;
  ${(p) => boxShadow(p.theme, `0 2px 10px rgba(0, 0, 0, 0.2)`)};
`;

/*
 * Component.
 */

export const FloatingBar: FC<FloatingBarProps> = ({className, children}) => (
  <StyledBarDiv className={className}>{children}</StyledBarDiv>
);
